import { render, staticRenderFns } from "./progressdialog.vue?vue&type=template&id=5b132a91&"
import script from "./progressdialog.js?vue&type=script&lang=js&"
export * from "./progressdialog.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\e-trailor\\EmployeePortalUpdated\\Frontend\\EmployeePortal.Portal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b132a91')) {
      api.createRecord('5b132a91', component.options)
    } else {
      api.reload('5b132a91', component.options)
    }
    module.hot.accept("./progressdialog.vue?vue&type=template&id=5b132a91&", function () {
      api.rerender('5b132a91', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientApp/components/shared/common/progressdialog.vue"
export default component.exports